import React, { useState, useRef, Suspense, lazy } from "react";
import * as styles from "./VideoPlayer.module.css";
import Modal from "react-modal";
import PlayArrow from "../PlayArrow/PlayArrow";
import CloseButton from "../CloseButton/CloseButton";
import { LoadingTile } from "../LoadingTile/LoadingTile";
const ReactPlayer = lazy(() => import("react-player/lazy"));

interface Props {
  src: string;
  thumbnail?: string | boolean;
  display?: "inline" | "overlay";
  className?: string;
  arrowSize?: string;
}

const VideoPlayer: React.FC<Props> = ({
  src,
  thumbnail = true,
  display = "inline",
  className,
  arrowSize = "4rem",
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  const previewPlayer = useRef() as any;

  const handleCloseClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setModalOpen(false);
    setIsPlaying(false);
    previewPlayer?.current?.showPreview(true);
  };

  const customModalStyles = {
    overlay: {
      zIndex: 1000,
    },
  };

  const handleClickPreview = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    if (display === "overlay") {
      setModalOpen(true);
    } else {
      setIsPlaying(true);
    }
  };

  return (
    <div className={styles.wrapper}>
      <Suspense fallback={<LoadingTile />}>
        <ReactPlayer
          url={src}
          playing={isPlaying}
          light={thumbnail}
          playIcon={<PlayArrow size={arrowSize} fillColor="#ffffff" />}
          style={{
            position: "absolute",
            top: "0",
            left: "0",
          }}
          ref={previewPlayer}
          className={className}
          height="100%"
          width="100%"
          controls={isPlaying}
          onClickPreview={handleClickPreview}
        />
      </Suspense>
      <Modal
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        contentLabel="Video Player"
        className={styles.modalContent}
        style={customModalStyles}
      >
        <div className={styles.closeButtonWrapper}>
          <CloseButton
            color="#000"
            onClick={handleCloseClick}
            className={styles.closeButton}
          />
        </div>

        <div
          className={styles.modalPlayerWrapper}
          style={{
            paddingTop: "56.25%",
          }}
        >
          <ReactPlayer
            url={src}
            style={{
              position: "absolute",
              top: "0",
              left: "0",
            }}
            height="100%"
            width="100%"
            controls
            playing
          />
        </div>
      </Modal>
    </div>
  );
};

export default VideoPlayer;
